import PropTypes from 'prop-types';
import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import RatingWrapper from './RatingWrapper';
import HiddenInput from './HiddenInput';
import RatingIcon from './RatingIcon';
import range from 'lodash/range';

const RatingQuestion = props => {
  const { id, isDisabled, name, rating_count, rating_shape } = props;
  return (
    <QuestionWrapper {...props}>
      <div>
        <HiddenInput name={`questions[${name}]`} questionId={id} />
        <RatingWrapper disabled={isDisabled}>
          {({ hoverVal, hover, onHoverOrFocus, onBlurOrMouseLeave }) =>
            range(rating_count).map(index => (
              <RatingIcon
                disabled={isDisabled}
                key={index}
                icon={rating_shape}
                isHovered={hover}
                hoverVal={hoverVal}
                onHoverOrFocus={onHoverOrFocus}
                onBlurOrMouseLeave={onBlurOrMouseLeave}
                questionId={id}
                value={index + 1}
              />
            ))
          }
        </RatingWrapper>
      </div>
    </QuestionWrapper>
  );
};

RatingQuestion.propTypes = {
  id: PropTypes.string.isRequired,
  matrix: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  rating_count: PropTypes.number.isRequired,
  rating_shape: PropTypes.string.isRequired,
  required: PropTypes.bool,
  text: PropTypes.string,
  value: PropTypes.number,
};

RatingQuestion.defaultProps = {
  rating_count: 5,
  rating_shape: 'star',
};

export default RatingQuestion;
